import {
    Environment,
    KameleoonProvider as KameleoonProviderSDK,
    createClient,
} from '@kameleoon/react-sdk';
import { useMemo } from 'react';
import { config } from '@lingoda/config';
import { getTopLevelDomain } from '@lingoda/urls';
import { KameleoonFeaturesProvider } from './context';
import type { PropsWithChildren } from 'react';

export const KameleoonProvider = ({ children }: PropsWithChildren<unknown>) => {
    const client = useMemo(
        () =>
            createClient({
                siteCode: config.kameleoonSiteCode,
                configuration: {
                    updateInterval: 5,
                    environment: getKameleoonEnvironment(config.deployEnvironment),
                    // we keep it for a minute so would be possible to resend it when needed.
                    targetingDataCleanupInterval: 1,
                    cookieDomain: getTopLevelDomain(window.location.hostname),
                },
            }),

        [],
    );

    return (
        <KameleoonProviderSDK client={client}>
            <KameleoonFeaturesProvider>{children}</KameleoonFeaturesProvider>
        </KameleoonProviderSDK>
    );
};

const getKameleoonEnvironment = (env: string) => {
    switch (env) {
        case 'production':
        case 'release':
            return Environment.Production;
        default:
            return Environment.Staging;
    }
};
